import type { StyleCollection, Collection } from '../gql';

import {
    randFloat,
    randNumber,
    randProductMaterial,
    randProductName,
} from '@ngneat/falso';

const mockCollection = (overwrite?: Partial<Collection>): Collection => ({
    collectionNumber: randNumber({ min: 1000, max: 9999 }),
    collectionName: randProductName(),
    collectionTerm: randProductMaterial(),
    ...overwrite,
    ['__typename']: 'Collection',
});

const mockStyleCollection = (
    overwrite?: Partial<StyleCollection>
): StyleCollection => ({
    brandNumber: randFloat({ min: 0.1, max: 2 }).toString().replaceAll('.', ''),
    collectionName: randProductName(),
    collectionNumber: randNumber({ min: 1000, max: 9999 }),
    collectionTerm: randProductMaterial(),
    ...overwrite,
    ['__typename']: 'Collection',
});

export { mockCollection, mockStyleCollection };
